import { withState } from 'recompose';

export default withState('filterButton', 'updateFilterButton', false);
